import Peony1 from './Peony.webp'
import Peony2 from './Peony.webp'


const Peonyimages =[
Peony1,Peony2
]

export default Peonyimages;